<template>
  <div style="padding: 10px 10px 10px 0">
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="巡检记录" name="1">
        <el-form :inline="true" :model="selectForm" ref="selectForm">
          <el-form-item label="日期" prop="date">
            <el-date-picker
              size="small"
              v-model="selectForm.date"
              type="date"
              placeholder="选择日期"
              :clearable="false"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getAll" size="small">查询</el-button>
          </el-form-item>
          <!-- <el-form-item>
                        <el-button type="primary" size="small" @click="query1();">重置</el-button>
                    </el-form-item> -->
          <!-- <el-form-item>
				<el-button type="primary" @click="addRow">新增</el-button>
			</el-form-item> -->
          <!-- <el-form-item>
				<el-button type="primary" @click="dc">导出</el-button>
			</el-form-item> -->
        </el-form>
        <!-- 表格 -->
        <el-table :data="data" style="width: 100%">
          <el-table-column
            prop="onDutyDate"
            label="时间"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="userName"
            label="巡检人"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="shiftTypeName"
            label="班次"
            align="center"
          ></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="viewRow(scope.row)">查看</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
          v-if="totalNum > 0"
          @size-change="sizeChange"
          @current-change="currentChange"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="selectForm.rows"
          :current-page="selectForm.page"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum"
          style="margin-top: 10px"
        >
        </el-pagination>
      </el-tab-pane>
      <el-tab-pane label="巡检路线" name="2">
        <el-form :inline="true" :model="twoForm" ref="twoForm">
          <el-form-item label="路线名称" prop="shitfName">
            <el-input
              v-model="twoForm.shitfName"
              clearable
              size="small"
              placeholder="请输入路线名称"
            ></el-input>
          </el-form-item>
          <el-form-item label="班次" prop="shiftType">
            <!-- <el-input v-model="" size="small" placeholder="请输入路线名称"></el-input> -->
            <el-select clearable v-model="twoForm.shiftType" placeholder="请选择班次">
              <el-option
                :label="item.label"
                :value="item.value"
                v-for="item in typeList"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="getAll2">查询</el-button>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="small"
              @click="
                $refs.twoForm.resetFields();
                query2();
              "
              >重置</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button type="primary" size="small" @click="add2">新增</el-button>
          </el-form-item>
        </el-form>
        <!-- 表格 -->
        <el-table :data="data2" style="width: 100%">
          <el-table-column
            prop="shitfName"
            label="路线名称"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="cameraCounts"
            label="绑定相机数"
            align="center"
          ></el-table-column>
          <el-table-column
            prop="shiftTypeName"
            label="所属班次"
            align="center"
          ></el-table-column>
          <el-table-column label="操作" align="center">
            <template slot-scope="scope">
              <el-button type="text" @click="edit2(scope.row)">编辑</el-button>
              <el-button type="text" @click="del2(scope.row)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
          v-if="totalNum2 > 0"
          @size-change="sizeChange2"
          @current-change="currentChange2"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="twoForm.rows"
          :current-page="twoForm.page"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalNum2"
          style="margin-top: 10px"
        >
        </el-pagination>
      </el-tab-pane>
      <!-- <el-tab-pane label="巡检时间" name="3">
                <el-form :inline="true">
                    <el-form-item>
                        <el-button type="primary" size="small" @click="add3">新增</el-button>
                    </el-form-item>
                </el-form>
                <el-table :data="data3" style="width: 100%">
                    <el-table-column prop="timeSlot" label="巡检时间段" align="center"></el-table-column>
                    <el-table-column prop="shiftTypeName" label="所属班次" align="center"></el-table-column>
                    <el-table-column label="操作" align="center">
                        <template slot-scope="scope">
                            <el-button type="text" @click="edit3(scope.row)">编辑</el-button>
                            <el-button type="text" @click="del3(scope.row)">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </el-tab-pane> -->
    </el-tabs>

    <el-dialog
      title="巡检路线"
      :visible.sync="show2"
      width="400px"
      :modal-append-to-body="false"
    >
      <el-form label-width="80px" :model="form2" ref="form2">
        <el-form-item label="路线名称" prop="shitfName">
          <el-input v-model="form2.shitfName" placeholder="请输入路线名称"></el-input>
        </el-form-item>
        <el-form-item label="班次类型" prop="shiftType">
          <!-- <el-input v-model="form2.shiftType"></el-input> -->
          <el-select
            style="width: 100%"
            v-model="form2.shiftType"
            placeholder="请选择班次类型"
          >
            <el-option
              v-for="item in typeList"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="绑定相机" prop="cameraIps">
          <!-- <el-input v-model="form2.shiftType"></el-input> -->
          <el-select
            style="width: 100%"
            v-model="form2.cameraIps"
            multiple
            placeholder="请选择绑定相机"
          >
            <el-option
              v-for="item in cameraList"
              :label="item.aliasName"
              :value="item.ipAddress"
            ></el-option>
          </el-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="show2 = false">取 消</el-button>
        <el-button type="primary" @click="submit2">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="巡检时间"
      :visible.sync="show3"
      width="580px"
      :modal-append-to-body="false"
    >
      <el-form label-width="80px" :model="form3" ref="form2">
        <el-form-item label="班次类型" prop="shiftType">
          <!-- <el-input v-model="form2.shiftType"></el-input> -->
          <el-select
            style="width: 100%"
            v-model="form3.shiftType"
            placeholder="请选择班次类型"
          >
            <el-option
              v-for="item in typeList"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="巡检时间">
          <el-time-select
            placeholder="起始时间"
            v-model="form3.startTime"
            :picker-options="{
              start: '00:00',
              step: '00:30',
              end: '24:00',
            }"
          >
          </el-time-select>
          -
          <el-time-select
            placeholder="结束时间"
            v-model="form3.endTime"
            :picker-options="{
              start: '00:00',
              step: '00:30',
              end: '24:00',
            }"
          >
          </el-time-select>
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <el-button @click="show3 = false">取 消</el-button>
        <el-button type="primary" @click="submit3">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
      title="巡检时间"
      :visible.sync="showOne"
      width="580px"
      :modal-append-to-body="false"
    >
      <div v-for="item in dataOne">
        <el-divider content-position="left">{{ item.timeSlot }}</el-divider>
        <div style="display: flex">
          <div
            style="
              margin-left: 20px;
              border: 1px solid #cccccc;
              text-align: center;
              padding: 5px 10px;
              border-radius: 5px;
            "
            v-for="(activity, index) in item.detailList"
            :key="index"
          >
            <div>相机</div>
            <div>{{ activity.aliasName }}</div>
            <div v-if="activity.signFlag" style="color: blue">已完成</div>
            <div v-else style="color: #ce9278">未完成</div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showOne = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import publicExport from "../../assets/js/publicExport.js";
export default {
  data() {
    return {
      show3: false,
      form3: {
        startTime: "",
        shiftType: "",
        endTime: "",
      },
      form2: {
        shitfName: "",
        shiftType: "",
        cameraIps: [],
      },
      activeName: "1",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            },
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            },
          },
        ],
      },
      data: [], //表格数据
      selectForm: {
        //查询条件
        page: 1, //当前页
        rows: 10, //页大小
        date: this.getDate(), //查询日期
      },
      twoForm: {
        //查询条件
        page: 1, //当前页
        rows: 10, //页大小
        shitfName: "",
        shiftType: "",
      },
      show: false, //控制弹窗
      title: "新增",
      typeList: [],
      totalNum: 0,
      totalNum2: 0,
      data2: [],
      data3: [],
      cameraList: [],
      show2: false,
      showOne: false,
      dataOne: [],
    };
  },
  methods: {
    submit2() {
      if (this.form2.shitfName == "") {
        this.$message.error("请输入路线名称");
        return;
      }
      if (this.form2.shiftType == "") {
        this.$message.error("请选择班次类型");
        return;
      }
      if (this.form2.cameraIps.length == 0) {
        this.$message.error("请选择绑定的相机");
        return;
      }
      let url = "/api/safe/inspect/shiftConfig/add";
      if (this.form2.id) {
        url = "/api/safe/inspect/shiftConfig/edit";
      }
      this.$http.post(url, this.form2).then((res) => {
        if (res.data.code == 200) {
          this.$message.success(res.data.msg);
          this.show2 = false;
          this.query2();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    submit3() {
      if (this.form3.shiftType == "") {
        this.$message.error("请选择班次类型");
        return;
      }
      if (this.form3.startTime == "") {
        this.$message.error("请选择开始时间");
        return;
      }
      if (this.form3.endTime == "") {
        this.$message.error("请选择开始时间");
        return;
      }
      this.form3.timeSlot = this.form3.startTime + "-" + this.form3.endTime;
      let url = "/api/safe/inspect/intervalConfig/add";
      if (this.form3.id) {
        url = "/api/safe/inspect/intervalConfig/edit";
      }
      this.$http.post(url, this.form3).then((res) => {
        if (res.data.code == 200) {
          this.$message.success(res.data.msg);
          this.show3 = false;
          this.getAll3();
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    handleClick() {
      if (this.activeName == 1) {
        this.query1();
      }
      if (this.activeName == 2) {
        this.query2();
      }
      if (this.activeName == 3) {
        this.getAll3();
      }
    },
    viewRow(row) {
      //查看
      let data = {
        date: row.onDutyDate,
        shiftType: row.shiftType,
        userId: row.userId,
      };
      this.dataOne = [];
      this.$http.post(`/api/safe/inspect/inspect/getDetail`, data).then((res) => {
        if (res.data.code == 200) {
          this.showOne = true;
          this.dataOne = res.data.data;
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    query1() {
      this.selectForm.page = 1;
      this.getAll();
    },
    query2() {
      this.twoForm.page = 1;
      this.getAll2();
    },
    getAll() {
      //获取表格数据
      this.$http
        .post(
          `/api/safe/inspect/inspect/pageQuery?pageNum=${this.selectForm.page}&pageSize=${this.selectForm.rows}`,
          this.selectForm
        )
        .then((res) => {
          if (res.data.code == 200) {
            this.data = res.data.rows;
            this.totalNum = res.data.total;
          } else {
            this.$message.error("查询失败");
          }
        });
    },
    getAll2() {
      //获取表格数据
      this.$http
        .post(
          `/api/safe/inspect/shiftConfig/pageQuery?pageNum=${this.twoForm.page}&pageSize=${this.twoForm.rows}`,
          this.twoForm
        )
        .then((res) => {
          if (res.data.code == 200) {
            this.data2 = res.data.rows;
            this.totalNum = res.data.total;
          } else {
            this.$message.error("查询失败");
          }
        });
    },
    getAll3() {
      //获取表格数据
      this.$http.post(`/api/safe/inspect/intervalConfig/pageQuery`, {}).then((res) => {
        if (res.data.code == 200) {
          this.data3 = res.data.rows;
        } else {
          this.$message.error("查询失败");
        }
      });
    },
    //
    channelQuery() {
      this.$http
        .post("/api/safe/ipChannel/queryList")
        .then((res) => {
          if (res.data.code == "200") {
            this.cameraList = res.data.data;
            // this.handleData();   //数据处理
          }
        })
        .catch((error) => {});
    },
    getTypeList() {
      this.$http.post(`/api/safe/inspect/shiftConfig/getTypes`, {}).then((res) => {
        if (res.data.code == 200) {
          for (let key in res.data.data) {
            let data = {
              label: res.data.data[key],
              value: key,
            };
            this.typeList.push(data);
          }
        }
      });
    },

    sizeChange(size) {
      //页大小被修改
      this.selectForm.rows = size;
      this.getAll();
    },
    currentChange(page) {
      //当前页被修改
      this.selectForm.page = page;
      this.getAll();
    },

    sizeChange2(size) {
      //页大小被修改
      this.twoForm.rows = size;
      this.getAll2();
    },
    currentChange2(page) {
      //当前页被修改
      this.twoForm.page = page;
      this.getAll2();
    },
    del2(row) {
      this.$confirm("确定该删除该数据吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http.post(`/api/safe/inspect/shiftConfig/delete`, [row.id]).then((res) => {
          if (res.data.code == 200) {
            this.query2();
            this.$message.success("删除成功");
          } else {
            this.$message.error("删除失败");
          }
        });
      });
    },
    del3(row) {
      this.$confirm("确定该删除该数据吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$http
          .post(`/api/safe/inspect/intervalConfig/delete`, [row.id])
          .then((res) => {
            if (res.data.code == 200) {
              this.getAll3();
              this.$message.success("删除成功");
            } else {
              this.$message.error("删除失败");
            }
          });
      });
    },
    edit2(row) {
      this.form2 = {
        id: "",
        shitfName: "",
        shiftType: "",
        cameraIps: [],
      };
      let row1 = JSON.parse(JSON.stringify(row));

      this.form2.id = row1.id;
      this.form2.shitfName = row1.shitfName;
      this.form2.shiftType = row1.shiftType;
      this.form2.cameraIps = row1.cameraIps;
      this.show2 = true;
    },
    edit3(row) {
      this.form3 = {
        id: "",
        startTime: "",
        shiftType: "",
        endTime: "",
      };
      let arr = row.timeSlot.split("-");
      let row1 = JSON.parse(JSON.stringify(row));
      this.form3.id = row1.id;
      this.form3.shiftType = row1.shiftType;
      this.form3.startTime = arr[0];
      this.form3.endTime = arr[1];
      this.show3 = true;
    },
    add2() {
      this.form2 = {
        shitfName: "",
        shiftType: "",
        cameraIps: [],
      };
      this.show2 = true;
    },
    add3() {
      this.form3 = {
        startTime: "",
        shiftType: "",
        endTime: "",
      };
      this.show3 = true;
    },
    getDate() {
      const nowDate = new Date();
      const date = {
        year: nowDate.getFullYear(),
        month: nowDate.getMonth() + 1,
        date: nowDate.getDate(),
      };
      const newmonth = date.month >= 10 ? date.month : "0" + date.month;
      const day = date.date >= 10 ? date.date : "0" + date.date;
      return date.year + "-" + newmonth + "-" + day;
    },
  },
  created() {
    this.getAll();
    this.getTypeList();
    this.channelQuery();
  },
};
</script>

<style scoped="scoped"></style>
